export class SignalRNotificationTypeConst {
  public static EDIT_NOTIFICATION = "edit";
  public static CREATE_NOTIFICATION = "create";
}
